module.exports = __webpack_public_path__ + "static/img/mainBack2.4258943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainBack2.jpg
// module id = DydT
// module chunks = 1